<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    spin?: boolean;
  }>(),
  { spin: true },
);
</script>

<template>
  <div class="ui-spinner">
    <Transition name="fade">
      <div v-if="props.spin" class="indicator" />
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.ui-spinner {
  width: px(24);
  height: px(24);
  display: flex;
  justify-content: center;
  align-items: center;
}

.indicator {
  width: 100%;
  height: 100%;
  border-top: px(3) solid currentColor;
  border-right: px(3) solid transparent;
  border-radius: var(--border-radius-circle);
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
